import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df224a70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex profileModal-body" }
const _hoisted_2 = { class: "tw-flex-1 tw-flex tw-flex-col tw-w-full tw-gap-[20px] tw-p-10 tw-order-[2] md:tw-order-[1] profileWrapper" }
const _hoisted_3 = { class: "tw-flex tw-justify-between tw-h-fit tw-w-full tw-items-center tw-flex-wrap tw-gap-[5px] profileMain" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 3,
  class: "tw-absolute tw-left-[91px] tw-top-1"
}
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-[7px] profileInfo" }
const _hoisted_7 = { class: "tw-text-[#211F58] tw-text-[22px] tw-font-medium tw-leading-[100%] name" }
const _hoisted_8 = { class: "tw-inline-flex md:tw-flex-col tw-flex-row tw-items-end tw-gap-[7px] secondaryInfo" }
const _hoisted_9 = { class: "tw-flex tw-items-center tw-gap-2.5 timeWrapper" }
const _hoisted_10 = { class: "tw-text-[#211F58] tw-text-[13px] time" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "button-container tw-flex tw-justify-end tw-mt-[30px]" }
const _hoisted_13 = { class: "tw-w-[360px] tw-shadow-[2px_0px_10px_0px_rgba(33,31,88,0.05)_inset] tw-order-[1] md:tw-order-[2] tw-flex tw-justify-center tw-rounded-br-md tw-rounded-bl-md actionsWrapper" }
const _hoisted_14 = { class: "tw-max-w-[280px] tw-flex tw-flex-col tw-gap-[25px] tw-w-full tw-mt-[25px] md:tw-mt-[65px] actions" }
const _hoisted_15 = { class: "tw-text-[#211F58] tw-text-[12px] tw-font-semibold tw-leading-[100%] tw-tracking-[1.2px] tw-uppercase actions-header" }
const _hoisted_16 = {
  key: 0,
  class: "tw-flex tw-flex-col tw-gap-[25px]"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "tw-w-[34px] tw-h-[34px] tw-flex tw-items-center tw-justify-center tw-rounded-[50%] icon_wrapper" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "right-arrow" }
const _hoisted_22 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-gap-[25px]"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "tw-w-[34px] tw-h-[34px] tw-flex tw-items-center tw-justify-center tw-rounded-[50%] icon_wrapper" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "title" }
const _hoisted_27 = { class: "right-arrow" }

import utilities, {
  IsEmailValidWhileTyping,
  IsSpecialCharEmailValid,
  getComponentUiText,
  handleSvg,
} from "@/utils/utilities";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "../common/modalHeader.vue";
import ClockIcon from "@/components/svgs/clockIcon.vue";
import BaseInput from "@/components/common/form/baseInput.vue";
import CustomMultiSelectSearch from "@/components/common/customMultiSelectSearch.vue";
import {
  deleteAvatarUser,
  putMemberRoles,
  verifyCurrentUser,
  verifyOtherUser,
} from "@/services/org";
import { IOrgRole } from "@/interfaces/org/role";
import ArrowRightIcon from "@/components/svgs/arrowRightIcon.vue";
import ResetPasswordIcon from "@/components/svgs/resetPasswordIcon.vue";
import CrossIcon from "@/components/svgs/crossIcon.vue";
import LockIcon from "@/components/svgs/lockIcon.vue";
import DeleteIcon from "@/components/svgs/deleteIcon.vue";
import LockedIcon from "@/components/svgs/lockedIcon.vue";
import { onMounted, onUpdated, PropType, ref, Ref, watch } from "vue";
import { IProfile, IProfileAction } from "@/interfaces/members/IProfile";
import { putMember } from "@/services/org";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import BaseForm from "../common/form/baseForm.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org, UserRoute } from "@/services/apiRoutes/routes";
import StatusBadge from "@/components/common/setting/statusBadge.vue";
import ImageCropper from "@/components/common/imageCropper.vue";
import BaseDropDown from "../common/form/baseDropDown.vue";
import { computed } from "vue";
import store from "@/store";
import cloneDeep from "lodash/cloneDeep";
import {
  DEFAULT_LANG_ID,
  MFAStatus,
  MODAL_NAME,
  successStatusCodes,
} from "@/utils/constants";
import userService from "@/services/user/userService";
import CloseAvatarIcon from "@/components/svgs/closeAvatarIcon.vue";
import EditIcon from "@/components/svgs/editIcon.vue";
import GlobalAvatar from "@/components/common/globalAvatar.vue";
import { uploadAvatarUser } from "@/services/org";
import { IModalMessage } from "@/interfaces/common/common";
import { toBase64 } from "@/utils/cipher";
import { fileSizeFormat } from "@/utils/dateTimeUtils";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'profileModal',
  props: {
  isInternal: { type: Boolean, default: false },
  isVisible: { type: Boolean, default: false },
  profile: { type: Object as PropType<IProfile>, required: true },
  existingProfile: { type: Object as PropType<IProfile>, required: true },
  isCurrentUser: { type: Boolean, default: false },
},
  emits: ["close", "showModal", "update:file", "showModalMFA"],
  setup(__props, { emit }) {

const props = __props;

const isImageCropperVisible = ref(false);
const imgSrc: any = ref(null);
const imgSrcString: any = ref(null);
const fileInput = ref<HTMLInputElement | null>(null);
const cropModalTitle = ref("Upload Avatar");
const cropFormats = ref("");
const croppedImage: any = ref(null);
const isSmallScreen = ref(false);


const fileTypeImage = ["image/jpeg", "image/png", "image/gif", "image/svg+xml"];
const profileData = ref<any>();
let selectedRoles: IOrgRole[] = [];
const languageList = computed(() => store.state.LanguagePicker.languageList);
const showRef: Ref<boolean> = ref(props.isVisible);
const listRolesByUser = computed(() => store.state.Org.listRolesByUser);
const profileRef: Ref<any> = ref({ ...props.profile, roles: listRolesByUser });
const salutation = computed(() => store.state.User.salutation);
const memberRoles: Ref<IOrgRole[]> = computed(() => store.state.Org.orgRoles);
const overflowModal = ref(true);
const isChanged = ref(false);
const isChangeRoles = ref(false);
const MAX_AVT_SIZE = process.env.VUE_APP_MAX_AVT_SIZE || 1048576;
const isLoadingButton = ref(false);

const rules = {
  fullName: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  roles: {
    required: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-role-invalid-special-characters-1"),
      required,
    ),
  },
  email: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsEmailValidWhileTyping,
    ),
    email: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsSpecialCharEmailValid,
    ),
  },
  company: {},
  title: {},
  role: {},
  salutation: {},
  languageId: {},
};

const checkScreenSize = () => {
  const screenWidth = window.innerWidth;
  if (screenWidth < 600) isSmallScreen.value = true;
};
const getImgUrl = (img = "default") => {
  try {
    return require("@/assets/img/flags/" + img.toLowerCase() + ".svg");
  } catch {
    return require("@/assets/img/flags/loading.svg");
  }
};
const handleDrop = (event) => {
  event.preventDefault();
  handleFileSelect(event);
};
const handleFileSelect = async (selectFile = null) => {
  if (selectFile) {
    imgSrc.value = selectFile;
    if (imgSrc.value?.type === "image/svg+xml") {
      imgSrc.value = await handleSvg(imgSrc.value);
    }
    imgSrcString.value = await toBase64(imgSrc.value);
    isImageCropperVisible.value = true;
  }
};

const handleScroll = (event) => {};

const handleChange = (event) => {
  const file = event.target.files[0];

  if (!file) return;

  if (file.size > MAX_AVT_SIZE) {
    const maxSizeConverted = fileSizeFormat(MAX_AVT_SIZE);

    showError(
      getComponentUiText(
        "app-component-file-upload-toast-message-invalid-file-size-error-1",
        false,
        { maxSize: maxSizeConverted },
      ),
    );

    return;
  }

  handleFileSelect(file);
  event.target.value = null;
};
const emitFile = async (canvas: any) => {
  if (!canvas) {
    imgSrc.value = null;
    return;
  }
  if (!fileTypeImage.includes(imgSrc.value?.type?.toLowerCase())) {
    showError(
      getComponentUiText("app-user-setting-team-member-invalid-file-error"),
    );
    return;
  }
  const blob: any = await new Promise((resolve) =>
    canvas.toBlob(resolve, imgSrc.value.type?.toLowerCase(), 1),
  );
  croppedImage.value = URL.createObjectURL(blob);
  const method = profileData.value?.avatar?.avatarAddedByUserId
    ? "put"
    : "post";
  await updateFile(
    new File([blob], imgSrc.value?.name, { type: blob.type }),
    method,
  );
  await getProfileData(props.profile.id);
};
const updateFile = async (file: any, method) => {
  try {
    const formData: FormData = new FormData();
    formData.append("file", file);
    await uploadAvatarUser(formData, method);
  } catch (error: any) {
    showErrorAPI(error, Org.orgUserUploadAvatar);
  }
};
const changeAvatar = () => {
  if (fileInput.value) {
    fileInput.value.click();
  }
};
const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};
let v$ = useVuelidate(rules, profileRef as any);

const profileActions: any = ref([]);

const profileActionsExternal: IProfileAction[] = [
  {
    icon: LockIcon,
    title: "app-settings-team-members-profile-modal-mfa-action-title-1",
    action: "showModalMFA",
  },
  {
    icon: DeleteIcon,
    title:
      "app-settings-team-members-profile-modal-actions-remove-all-access-1",
    class: "delete",
    action: "showModalRemoveAccess",
  },
];

onMounted(() => {
  getActionsData();
  checkScreenSize();
});

watch(
  () => props.isVisible,
  async (value) => {
    if (value) {
      profileRef.value = {
        ...props.profile,
        ...profileData.value,
      };
      await getProfileData(props.profile.id);
    }
  },
);

onUpdated(() => {
  getActionsData();
});

const currentUserId = computed(() => store.state.User.currentUser.id);

const getProfileData = async (id: string) => {
  try {
    profileData.value = { ...profileData.value, salutationId: "" };
    const res = await userService.getUserProfile(id);
    profileData.value = res.data.data;
    if (profileData.value.avatar?.avatarImageFileId) {
      const imageData = await userService.getUserProfileImage(
        profileData.value.avatar?.avatarImageFileId,
      );
      const file = utilities.base64ToFile(
        imageData.data.data.file,
        imageData.data.data.fileName,
        imageData.data.data.fileType,
      );
      if (id === currentUserId.value) {
        store.commit("User/SET_AVATAR_CURRENT", URL.createObjectURL(file));
      }
      profileData.value.avatar.file = URL.createObjectURL(file);
    }
    profileRef.value = { ...profileRef.value, ...profileData.value };
  } catch (error) {
    showErrorAPI(error, UserRoute.getUserProfile);
  }
};

const setupRoleData = () => {
  const rolesSelected = props.profile
    ? (props.profile.roles || []).map((item) => {
        return {
          ...item,
        } as IOrgRole;
      })
    : [];
  selectedRoles = rolesSelected;
};

const getActionsData = async () => {
  let actions: any;
  if (props.isCurrentUser) {
    switch (profileRef.value?.mfaEnabled) {
      case MFAStatus.REGISTERED:
      case MFAStatus.REGISTERED_PK:
      case MFAStatus.REGISTERED_PKONLY: {
        actions = [
          {
            icon: ResetPasswordIcon,
            title: "app-user-profile-actions-reset-password-1",
            action: "showModalPassword",
          },
          {
            icon: LockIcon,
            title:
              "app-settings-team-members-profile-modal-add-another-mfa-action-title-1",
            action: "showModalAddAnotherMFA",
          },
          {
            icon: LockIcon,
            title: "app-settings-team-members-profile-modal-mfa-action-title-1",
            action: "showModalMFA",
          },
        ];
        break;
      }
      case MFAStatus.NOT_REGISTERED:
      case MFAStatus.NOT_REQUIRED:
      default: {
        actions = [
          {
            icon: ResetPasswordIcon,
            title: "app-user-profile-actions-reset-password-1",
            action: "showModalPassword",
          },
          {
            icon: LockIcon,
            title:
              "app-settings-team-members-profile-modal-add-mfa-action-title-1",
            action: "showModalAddMFA",
          },
        ];
        break;
      }
    }
  } else {
    switch (props.profile?.mfaEnabled) {
      case MFAStatus.REGISTERED:
      case MFAStatus.REGISTERED_PK:
      case MFAStatus.REGISTERED_PKONLY: {
        actions = [
          {
            icon: ResetPasswordIcon,
            title: "app-user-profile-actions-reset-password-1",
            action: "showModalPassword",
          },
          {
            icon: LockIcon,
            title: "app-settings-team-members-profile-modal-mfa-action-title-1",
            action: "showModalMFA",
          },
          {
            icon: CrossIcon,
            title: props.existingProfile.isDeactivated
              ? "app-user-profile-actions-activate-user-1"
              : "app-user-profile-actions-deactivate-user-1",
            action: props.existingProfile.isDeactivated
              ? "showModalActivate"
              : "showModalDeactivate",
          },
          {
            icon: DeleteIcon,
            title: "app-user-profile-actions-delete-user-1",
            class: "delete",
            action: "showModalDelete",
          },
        ];
        break;
      }
      case MFAStatus.NOT_REGISTERED:
      case MFAStatus.NOT_REQUIRED:
      default: {
        actions = [
          {
            icon: ResetPasswordIcon,
            title: "app-user-profile-actions-reset-password-1",
            action: "showModalPassword",
          },
          {
            icon: LockIcon,
            title:
              "app-settings-team-members-profile-modal-enable-mfa-action-title-1",
            action: "showModalMFA",
          },
          {
            icon: CrossIcon,
            title: props.existingProfile.isDeactivated
              ? "app-user-profile-actions-activate-user-1"
              : "app-user-profile-actions-deactivate-user-1",
            action: props.existingProfile.isDeactivated
              ? "showModalActivate"
              : "showModalDeactivate",
          },
          {
            icon: DeleteIcon,
            title: "app-user-profile-actions-delete-user-1",
            class: "delete",
            action: "showModalDelete",
          },
        ];
        break;
      }
    }
    if (props.existingProfile.isLocked) {
      const lockItem = {
        icon: LockedIcon,
        title: "app-settings-team-members-profile-modal-actions-unlock-user-1",
        action: "showModalUnlock",
      };
      actions.splice(-1, 0, lockItem);
    }
  }
  profileActions.value = actions;
};

const deleteAvatar = async () => {
  profileData.value.avatar = {
    avatarImageFileId: null,
    file: null,
    avatarAddedByUserId: null,
  };
};

const initialData = () => {
  profileRef.value = { ...props.profile, ...profileData.value };
  v$ = useVuelidate(rules, profileRef as any);
};

watch(
  () => props.isVisible,
  (value) => (showRef.value = value),
);

// watch(
//   () => currentUser.value,
//   (value) => getProfileData(value.id),
// );

watch(
  () => props.profile,
  () => {
    initialData();
    setupRoleData();
  },
);

const saveChanges = async () => {
  await v$.value.$validate();
  if (v$.value.$invalid) return;
  if (profileRef.value.email !== props.profile.email) {
    const emailTo = cloneDeep(profileRef.value.email);
    await doSaveChanges();
    verifyEmail(emailTo);
    return;
  } else {
    doSaveChanges();
  }
};

const doSaveChanges = async () => {
  try {
    isLoadingButton.value = true;
    await new Promise((resolve) => setTimeout(resolve, 500));

    if (isChangeRoles.value) {
      const roleIds: any[] = profileRef.value.roles.map(
        (item) => `${item.roleId}`,
      );
      await putMemberRoles(profileRef.value.id, roleIds);
      isChangeRoles.value = false;
    }
    isChangeRoles.value = false;
    let emitData: IToastMessage = {
      variant: ToastVariant.SUCCESS,
      message:
        getComponentUiText("app-settings-team-members-roles-updated-toast-1") ||
        "",
    };
    EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    const splittedName: string[] = profileRef.value.fullName.split(" ");
    const payload: any = {
      firstName: splittedName[0],
      lastName: splittedName.splice(1).join(" "),
      title: profileRef.value.title,
    };
    if (props.isCurrentUser && isChanged.value) {
      await store.dispatch("User/updateUserProfile", {
        data: {
          ...payload,
          languageId: profileRef.value.languageId,
          salutationId: profileRef.value.salutationId,
        },
      });
      isChanged.value = false;
      if (profileRef.value.languageId !== profileData.value.languageId) {
        const language: any = Object.values(languageList.value).find(
          (item: any) => item?.id === profileRef?.value?.languageId,
        );
        store.dispatch("LanguagePicker/setSelectedLanguage", language.id);
        store.dispatch("User/updateUserProfile", {
          data: { languageId: language?.id || DEFAULT_LANG_ID },
        });
      }
    } else {
      await putMember(profileRef.value.id, payload);
    }
    emitData = {
      variant: ToastVariant.SUCCESS,
      message:
        getComponentUiText(
          "app-settings-team-members-profile-updated-toast-1",
        ) || "",
    };
    EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    if (
      !profileData.value.avatar.file &&
      profileRef.value.avatar.avatarImageFileId
    ) {
      await deleteAvatarUser(profileRef.value.avatar.avatarImageFileId);
      store.commit("User/SET_AVATAR_CURRENT", null);
    }
    if (profileData.value?.languageId === profileRef.value.languageId) {
      EventEmitter.emit(
        EmitterEvents.RELOAD_MANAGE_MEMBERSHIPS,
        props.isInternal,
      );
      EventEmitter.emit(EmitterEvents.RELOAD_CURRENT_USER_MEMBERSHIPS);
    } else {
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.putMemberRoles);
    }
  } finally {
    isLoadingButton.value = false;
  }

  emit("close");
};
const showModal = (action: string) => {
  if (action === "showModalMFA") {
    emit("showModalMFA", {
      isCurrentUser: props.isCurrentUser,
      user: props.profile,
    });
    return;
  } else {
    emit("showModal", action);
  }
};

const verifyEmail = async (emailTo) => {
  try {
    let res;
    if (props.isCurrentUser) {
      res = await verifyCurrentUser({
        emailTo: emailTo,
      });
    } else {
      res = await verifyOtherUser(profileRef.value.id, {
        emailTo: emailTo,
      });
    }

    if (res.status === successStatusCodes.OK) {
      openUpdateEmailModal(res.data.data.secret);
    }
  } catch (error: any) {
    showErrorAPI(error, Org.postOrgMemberVerify);
  }
};

const openUpdateEmailModal = async (secret = "") => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.VERIFY_ADD_DOMAIN,
    properties: {
      value: {},
      subTitle: props.isCurrentUser
        ? "app-profile-modal-update-email-address-secret-sub-title-1"
        : "app-profile-modal-update-other-user-email-address-secret-sub-title-1",
      secret,
      isVerifiedEmail: true,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-flex tw-flex-col profileModal",
    visible: __props.isVisible,
    value: profileRef.value,
    overflow: overflowModal.value,
    onClose: _cache[26] || (_cache[26] = ($event: any) => (emit('close', true)))
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        title: _unref(getComponentUiText)('app-user-profile-title-1'),
        onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(`tw-flex tw-justify-between tw-items-center tw-gap-[25px] profile ${
              __props.isCurrentUser ? 'tw-cursor-pointer tw-relative' : ''
            }`)
            }, [
              (__props.isCurrentUser)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    ref_key: "fileInput",
                    ref: fileInput,
                    class: "tw-invisible tw-w-0 tw-h-0",
                    type: "file",
                    onChange: _cache[1] || (_cache[1] = (e) => handleChange(e))
                  }, null, 544))
                : _createCommentVNode("", true),
              (profileData.value?.avatar?.file)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: profileData.value?.avatar?.file ?? '',
                    alt: profileData.value?.avatar?.avatarFileName || 'avatar',
                    "data-cy": "profile-modal-avatar-image",
                    class: "tw-w-[90px] tw-h-[90px] tw-rounded-[50%] profilePicture",
                    onClick: changeAvatar,
                    onDrop: handleDrop
                  }, null, 40, _hoisted_4))
                : (_openBlock(), _createBlock(GlobalAvatar, {
                    key: 2,
                    class: "tw-cursor-pointer",
                    name: profileRef.value?.fullName || profileRef.value?.email,
                    "class-name": 'modal-profile-avatar-icon',
                    "data-cy": "profile-modal-avatar-image",
                    onClick: changeAvatar,
                    onDrop: handleDrop
                  }, null, 8, ["name"])),
              (__props.isCurrentUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (profileData.value?.avatar?.file)
                      ? (_openBlock(), _createBlock(CloseAvatarIcon, {
                          key: 0,
                          "data-cy": "profile-modal-delete-avatar-button",
                          onClick: deleteAvatar
                        }))
                      : (_openBlock(), _createBlock(EditIcon, {
                          key: 1,
                          "data-cy": "profile-modal-edit-avatar-button",
                          onClick: changeAvatar
                        }))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(profileRef.value.fullName || profileRef.value.email), 1)
              ])
            ], 2),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(ClockIcon, {
                  size: 20,
                  color: "#211F58"
                }),
                _createElementVNode("span", _hoisted_10, _toDisplayString(__props.existingProfile.lastActive) + " " + _toDisplayString(_unref(getComponentUiText)("app-user-profile-local-time-1")), 1)
              ]),
              (__props.existingProfile.status)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(StatusBadge, {
                      value: __props.existingProfile?.status
                    }, null, 8, ["value"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(BaseForm, {
            "enter-event": true,
            show: __props.isVisible,
            "onOn:submit": saveChanges
          }, {
            default: _withCtx(() => [
              _createVNode(BaseInput, {
                modelValue: profileRef.value.fullName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((profileRef.value.fullName) = $event)),
                "data-cy-id": "profile-modal-full-name-input",
                validation: _unref(v$).fullName,
                "validate-on-blur": true,
                placeholder: 
              _unref(getComponentUiText)('app-user-profile-form-label-full-name-1')
            ,
                label: 
              _unref(getComponentUiText)('app-user-profile-form-label-full-name-1')
            ,
                "class-name": 'align-items-center',
                onChange: _cache[3] || (_cache[3] = ($event: any) => (isChanged.value = true)),
                onBlur: _cache[4] || (_cache[4] = 
              () => {
                _unref(v$).fullName.$validate();
              }
            )
              }, null, 8, ["modelValue", "validation", "placeholder", "label"]),
              (__props.isCurrentUser)
                ? (_openBlock(), _createBlock(BaseInput, {
                    key: 0,
                    id: "salutation",
                    modelValue: profileRef.value.salutationId,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((profileRef.value.salutationId) = $event)),
                    validation: _unref(v$).salutation,
                    placeholder: 
              _unref(getComponentUiText)(
                'app-settings-team-members-profile-modal-salutation-title-1',
              )
            ,
                    label: 
              _unref(getComponentUiText)(
                'app-settings-team-members-profile-modal-salutation-title-1',
              )
            ,
                    "class-name": 'align-items-center',
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (isChanged.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(BaseDropDown, {
                        id: 'salutation',
                        modelValue: profileRef.value.salutationId,
                        "onUpdate:modelValue": [
                          _cache[5] || (_cache[5] = ($event: any) => ((profileRef.value.salutationId) = $event)),
                          _cache[6] || (_cache[6] = 
                (value) => {
                  profileRef.value.salutationId = value;
                  isChanged.value = true;
                }
              )
                        ],
                        "data-cy-id": "profile-modal-salutation-input",
                        data: salutation.value,
                        validation: _unref(v$).salutation,
                        "class-name": 'gray-dropdown-container tw-h-[58px]',
                        placeholder: 'Salutation'
                      }, null, 8, ["modelValue", "data", "validation"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "validation", "placeholder", "label"]))
                : _createCommentVNode("", true),
              (__props.isInternal)
                ? (_openBlock(), _createBlock(BaseInput, {
                    key: 1,
                    modelValue: profileRef.value.company,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((profileRef.value.company) = $event)),
                    "data-cy-id": "profile-modal-company-input",
                    validation: _unref(v$).company,
                    placeholder: _unref(getComponentUiText)('app-menu-submenu-settings-org-1'),
                    label: _unref(getComponentUiText)('app-menu-submenu-settings-org-1'),
                    "class-name": 'align-items-center tw-pointer-events-none',
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (isChanged.value = true))
                  }, null, 8, ["modelValue", "validation", "placeholder", "label"]))
                : _createCommentVNode("", true),
              (!__props.isInternal)
                ? (_openBlock(), _createBlock(BaseInput, {
                    key: 2,
                    modelValue: profileRef.value.company,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((profileRef.value.company) = $event)),
                    "data-cy-id": "profile-modal-company-input",
                    validation: _unref(v$).company,
                    placeholder: 
              _unref(getComponentUiText)('app-user-profile-form-label-company-1')
            ,
                    label: _unref(getComponentUiText)('app-user-profile-form-label-company-1'),
                    "class-name": 'align-items-center tw-pointer-events-none',
                    onChange: _cache[12] || (_cache[12] = ($event: any) => (isChanged.value = true))
                  }, null, 8, ["modelValue", "validation", "placeholder", "label"]))
                : _createCommentVNode("", true),
              _createVNode(BaseInput, {
                modelValue: profileRef.value.email,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((profileRef.value.email) = $event)),
                "data-cy-id": "profile-modal-email-input",
                validation: _unref(v$).email,
                "validate-on-blur": true,
                placeholder: 
              _unref(getComponentUiText)('app-user-profile-form-label-email-1')
            ,
                label: _unref(getComponentUiText)('app-user-profile-form-label-email-1'),
                "class-name": 'align-items-center',
                onChange: _cache[14] || (_cache[14] = ($event: any) => (isChanged.value = true)),
                onBlur: _cache[15] || (_cache[15] = 
              () => {
                _unref(v$).email.$validate();
              }
            )
              }, null, 8, ["modelValue", "validation", "placeholder", "label"]),
              _createVNode(BaseInput, {
                modelValue: profileRef.value.title,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((profileRef.value.title) = $event)),
                "data-cy-id": "profile-modal-title-input",
                validation: _unref(v$).title,
                placeholder: 
              _unref(getComponentUiText)('app-user-profile-form-label-title-1')
            ,
                label: _unref(getComponentUiText)('app-user-profile-form-label-title-1'),
                "class-name": 'align-items-center',
                onChange: _cache[17] || (_cache[17] = ($event: any) => (isChanged.value = true))
              }, null, 8, ["modelValue", "validation", "placeholder", "label"]),
              _createVNode(_component_b_row, { class: "field-container tw-flex tw-justify-between tw-items-center tw-my-[20px] tw-mx-[-15px]" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    sm: "5",
                    class: "label-container col-sm-5 tw-min-w-[65px] tw-text-[14px] tw-font-medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                  "app-component-custom-b-dropdown-label-roles-1",
                )), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_col, {
                    sm: "7",
                    class: "input-container dropdown col-sm-7"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CustomMultiSelectSearch, {
                        modelValue: profileRef.value.roles,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((profileRef.value.roles) = $event)),
                        "track-by": "roleName",
                        validation: _unref(v$).roles,
                        label: "roleName",
                        options: memberRoles.value,
                        placeholder: `${_unref(getComponentUiText)(
                  'app-component-custom-b-dropdown-label-roles-1',
                )}`,
                        "show-check-box": true,
                        "onChange:modal": _cache[19] || (_cache[19] = ($event: any) => (isChangeRoles.value = true))
                      }, null, 8, ["modelValue", "validation", "options", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (__props.isCurrentUser)
                ? (_openBlock(), _createBlock(BaseInput, {
                    key: 3,
                    id: "preferredLanguage",
                    modelValue: profileRef.value.languageId,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((profileRef.value.languageId) = $event)),
                    validation: _unref(v$).languageId,
                    placeholder: 
              _unref(getComponentUiText)(
                'app-settings-team-members-profile-modal-preferred-language-title-1',
              )
            ,
                    label: 
              _unref(getComponentUiText)(
                'app-settings-team-members-profile-modal-preferred-language-title-1',
              )
            ,
                    "class-name": 'align-items-center',
                    onChange: _cache[23] || (_cache[23] = ($event: any) => (isChanged.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(BaseDropDown, {
                        id: 'preferredLanguage',
                        modelValue: profileRef.value.languageId,
                        "onUpdate:modelValue": [
                          _cache[20] || (_cache[20] = ($event: any) => ((profileRef.value.languageId) = $event)),
                          _cache[21] || (_cache[21] = 
                (value) => {
                  profileRef.value.languageId = value;
                  isChanged.value = true;
                }
              )
                        ],
                        "data-cy-id": "profile-modal-language-input",
                        data: 
                Object.values(languageList.value).map((item) => {
                  return { ...item, iconSrc: getImgUrl(item.id) };
                })
              ,
                        validation: _unref(v$).languageId,
                        "class-name": 'gray-dropdown-container tw-h-[58px]',
                        placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-team-members-profile-modal-preferred-language-title-1',
                )
              
                      }, null, 8, ["modelValue", "data", "validation", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "validation", "placeholder", "label"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_b_button, {
                  type: "submit",
                  "data-cy": "profile-modal-submit-button",
                  variant: "primary",
                  class: "btn-submit tw-bg-[#387DFF] tw-h-[46.5px] tw-py-0 tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
                }, {
                  default: _withCtx(() => [
                    (isLoadingButton.value)
                      ? (_openBlock(), _createBlock(_unref(LottieAnimation), {
                          key: 0,
                          class: _normalizeClass('tw-h-[46.5px]'),
                          "animation-data": _unref(ProgressAnimation),
                          "auto-play": true,
                          loop: true
                        }, null, 8, ["animation-data"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)("app-common-save-change-button-1")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(getComponentUiText)("app-settings-action-menu-title-1")), 1),
            (__props.isInternal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileActions.value, (action, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(`tw-flex tw-w-full tw-justify-between tw-cursor-pointer action ${action.class} tw-items-center`)
                    }, [
                      _createElementVNode("button", {
                        class: "tw-border-none tw-bg-transparent tw-flex tw-items-center tw-flex-1 tw-text-[#211F58] tw-text-[15px] tw-font-medium tw-leading-[100%] tw-gap-2.5 title_wrapper",
                        onClick: ($event: any) => (showModal(action.action))
                      }, [
                        _createElementVNode("span", _hoisted_18, [
                          (typeof action.icon === 'string')
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: action.icon,
                                alt: "reset_password",
                                class: "tw-h-[18px] tw-w-[18px] icon"
                              }, null, 8, _hoisted_19))
                            : (_openBlock(), _createBlock(_resolveDynamicComponent(action.icon), {
                                key: 1,
                                color: action.iconColor,
                                class: "tw-h-[18px] tw-w-[18px]"
                              }, null, 8, ["color"]))
                        ]),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(getComponentUiText)(action.title)), 1)
                      ], 8, _hoisted_17),
                      _createElementVNode("span", _hoisted_21, [
                        _createVNode(ArrowRightIcon)
                      ])
                    ], 2))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(profileActionsExternal, (action, index) => {
                    return _createElementVNode("div", {
                      key: index,
                      class: _normalizeClass(`tw-flex tw-w-full tw-justify-between tw-cursor-pointer action ${action.class} tw-items-center`)
                    }, [
                      _createElementVNode("button", {
                        class: "tw-border-none tw-bg-transparent tw-flex tw-items-center tw-flex-1 tw-text-[#211F58] tw-text-[15px] tw-font-medium tw-leading-[100%] tw-gap-2.5 title_wrapper",
                        onClick: ($event: any) => (showModal(action.action))
                      }, [
                        _createElementVNode("span", _hoisted_24, [
                          (typeof action.icon === 'string')
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: action.icon,
                                alt: "reset_password",
                                class: "tw-h-[18px] tw-w-[18px] icon"
                              }, null, 8, _hoisted_25))
                            : (_openBlock(), _createBlock(_resolveDynamicComponent(action.icon), {
                                key: 1,
                                color: action.iconColor,
                                class: "tw-h-[18px] tw-w-[18px]"
                              }, null, 8, ["color"]))
                        ]),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(getComponentUiText)(action.title)), 1)
                      ], 8, _hoisted_23),
                      _createElementVNode("span", _hoisted_27, [
                        _createVNode(ArrowRightIcon)
                      ])
                    ], 2)
                  }), 64))
                ]))
          ])
        ])
      ]),
      _createElementVNode("div", { onScroll: handleScroll }, [
        _createVNode(ImageCropper, {
          visible: isImageCropperVisible.value,
          src: imgSrcString.value,
          title: cropModalTitle.value,
          formats: cropFormats.value,
          "is-small-screen": isSmallScreen.value,
          "class-name": 'top-of-sub-modal',
          onCroppedImg: _cache[24] || (_cache[24] = 
          (blob) => {
            emitFile(blob);
            isImageCropperVisible.value = false;
          }
        ),
          onClose: _cache[25] || (_cache[25] = 
          () => {
            emitFile(null);
            isImageCropperVisible.value = false;
          }
        )
        }, null, 8, ["visible", "src", "title", "formats", "is-small-screen"])
      ], 32)
    ]),
    _: 1
  }, 8, ["visible", "value", "overflow"]))
}
}

})